export const DISHES = [
  {
    id: 0,
    name:'Aloo Paratha',
    image: 'assets/images/AlooParatha.jpg',
    category: 'mains',
    label:'Hot',
    price:'40 ₹',
    featured: true, 
    description:'Aloo paratha are Indian breakfast flatbreads made with whole wheat flour, mashed potatoes, spices & herbs. These flavorful and delicious stuffed parathas are a staple in many North Indian households. These are most commonly topped with white butter and served alongside pickle and yogurt.',
                        },
 {
    id: 1,
    name:'Kadai Paneer',
    image: 'assets/images/KadaiPaneer.jpg',
    category: 'appetizer',
    label:'',
    price:'100 ₹',
    featured: false,
    description:'Kadai Paneer is a popular paneer recipe where paneer and bell peppers are cooked in a spicy masala. It is one of the most popular paneer recipes. Its there on the menu in almost all Indian restaurants',
    
                         },
    {
       id: 2,
       name:'Chole Bhature',
       image: 'assets/images/CholeBhature.jpg',
       category: 'appetizer',
       label:'New',
       price:'60 ₹',
       featured: false,
       description:'Sort of the unofficial dish of New Delhi, though its popular elsewhere in North India, chole bhature is a Punjabi concoction of spicy curried chickpeas (chole) and puffy fried white-flour bread (bhature), most often eaten together for breakfast (its also known as chana bhatura).',
                                           },
       {
        id: 3   ,
        name:'Butter Chicken',
        image: 'assets/images/butterchicken.jpg',
        category: 'appetizer',
        label:'New',
        price:'500 ₹',
        featured: false,
        description:'Chunks of grilled chicken (tandoori chicken) cooked in a smooth buttery & creamy tomato based gravy is known as Butter chicken or murgh makhani. It was invented by Kundan lal Gujral, who was the owner of a popular restaurant named Moti Mahal in Delhi.',
                  }
    ]